import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentSessionService } from 'src/app/shared/services/current-session.service';
import { Report, RowActions } from '../../report';
import { ProductsReportService } from './products-report.service';

@Component({
  selector: 'app-products-report',
  templateUrl: './products-report.component.html',
  styleUrls: ['./products-report.component.scss']
})
export class ProductsReportComponent implements OnInit {
  @Input() businessId!: number;
  public businessID: any;

  public requestBody: Report = {};
  public loading = false;
  isAssignedBusinessSelected: boolean = false
  public displayedColumns = ["name", "visitorCount", "totalSales", "creation", "code", "type", "BusinessName", "createdBy"];

  public displayTableColumns = {
    name: "product Name",
    visitorCount: "visitor Count",
    totalSales: "total Sales",
    creation: "Creation Date",
    type: "Product Type",
    BusinessName: "Shop Name",
    createdBy: "Created By",
  };
  public filterFields = [
    {
      filterFieldName: "type",
      filterDisplayName: "Type",
      defaultValue: null,
      filterOptions: [
        { key: "Show All", value: null },
        { key: "Event", value: "Event" },
        { key: "Reservation", value: "Reservation" },
        { key: "Invoice", value: "Invoice" },
        { key: "Physical Product", value: "Physical Product" },
        { key: "Quick Payment", value: "Quick Payment" },
        { key: "Quick Qassatly", value: "Quick Qassatly"},
        { key: "Quick Cash", value: "Quick Cash"},
        { key: "Subscription", value: "Subscription" },
        { key: "Custom Payment", value: "Custom Payment"},
        { key: "Fawry Payout", value: "Fawry Payout" },
        { key: "Calendar", value: "Calendar"},
        { key: "Direct Pay", value: "Direct Pay"},
      ]
    }
  ];
  public rowActions: RowActions[] = [
    {
      actionName: "View",
      actionType: "icon",
      iconClass: "fa-eye"
    }
  ];
  public tableData: any;
  public numPages: any;

  constructor(public fetchService: ProductsReportService,
    private router: Router,
    private getCurrentSessionService: CurrentSessionService,
    private activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(a => {
      this.businessID = a["id"];
      if (this.businessID) {
        this.requestBody.filterOptions = {
          BusinessId: this.businessID
        };
      }
    });
    try {
      this.fetchService.activateLoader();
      this.requestBody.paginationOptions = {
        start: 0,
        limit: 10
      };

      await this.updateTable();
    } catch (err) {
      console.log(err);
    }
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
      if (this.businessId) {
        this.requestBody.filterOptions = {
          BusinessId: this.businessId
        };
      }
    } else {
      if (this.businessId) {
        this.requestBody.filterOptions = {
          BusinessId: this.businessId
        };
      } else {
        this.requestBody.filterOptions = undefined;
      }
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    await this.updateTable();
    this.fetchService.loader().subscribe(val => (this.loading = val));
  }

  rowActionClicked(event: any) {
    if (event.action === "View") {
      this.view(event.key);
    }
  }

  view(product: any) {
    this.router.navigate([`${product.code}`]);
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    await this.updateTable();
    this.fetchService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = undefined;
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.fetchService.activateLoader();
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    this.fetchService.setParams(this.requestBody);
    const report = await this.fetchService.make();

    this.tableData = report.result.map((p: any) => {
      p.totalSales = JSON.stringify(p.totalSales);
      return p;
    });
    this.numPages = report.totalNumberOfRows;
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }
}
